import { MailIcon, PhoneIcon } from 'lucide-react'

import {
  AGENCY_EMAIL,
  AGENCY_LOCATION_LABEL,
  AGENCY_OPENING_HOURS_LABEL,
  AGENCY_PHONE,
  REUNION_ADDRESS,
  REUNION_EMAIL,
  REUNION_OPENING_HOURS_LABEL,
  REUNION_PHONE,
} from '@/lib/constants/agency'

import { CloudyCopiableContactCard } from './cloudy-copiable-contact-card'
import { WhatsappCallCloudyCard, WhatsappMessageCloudyCard } from './whatsapp-components'

interface PaymentConfirmationSharedScreenProps {
  /**
   * Vrai quand l'agence Réunion suit l'affaire. Toujours résolu depuis l'agence
   * portée par le dossier (`booking.agency` / `summary.agency`), jamais depuis
   * le lieu de départ : un dossier transféré doit afficher les coordonnées de sa
   * nouvelle agence.
   */
  isReunionAgency?: boolean
}

export function PaymentConfirmationSharedScreen({
  isReunionAgency,
}: PaymentConfirmationSharedScreenProps) {
  const isReunion = isReunionAgency ?? false

  const phone = isReunion ? REUNION_PHONE : AGENCY_PHONE
  const email = isReunion ? REUNION_EMAIL : AGENCY_EMAIL
  const locationLabel = isReunion
    ? `Massilia Voyages agence La Réunion : ${REUNION_ADDRESS}`
    : AGENCY_LOCATION_LABEL
  const openingHours = isReunion ? REUNION_OPENING_HOURS_LABEL : AGENCY_OPENING_HOURS_LABEL

  return (
    <div className="flex w-full flex-col gap-10 pb-7">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <CloudyCopiableContactCard
          icon={PhoneIcon}
          label="Téléphone"
          title="Nous appeler !"
          value={phone}
        />
        <CloudyCopiableContactCard
          icon={MailIcon}
          label="Adresse email"
          title="Par email"
          value={email}
        />
        <WhatsappCallCloudyCard />
        <WhatsappMessageCloudyCard />
      </div>
      <div className="flex flex-col gap-7 rounded-2xl border border-gray-light-200 bg-white p-4 md:p-6">
        <div className="text-lg font-semibold text-gray-light-900 sm:text-2xl">
          Votre agence de voyage
        </div>
        <div className="flex flex-col gap-3">
          <div className="text-sm font-semibold text-gray-900">{locationLabel}</div>
          <div className="text-sm text-gray-900">{openingHours}</div>
          <div className="text-sm text-gray-900">Téléphone : {phone}</div>
        </div>
      </div>
    </div>
  )
}
